module.exports = __webpack_public_path__ + "faqCover.d119c699674760066ca8.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/faqCover.jpg
// module id = ../../../../../src/assets/coverPicks/faqCover.jpg
// module chunks = 0